module.exports = __webpack_public_path__ + "first-20-paper.jpg?3992982aa2df6b737c134a00146d64ce";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20-paper.jpg
// module id = 460
// module chunks = 0